import { FunctionComponent } from 'react';
import { CompanyDelta } from './interfaces';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { HStack, Link } from '@montel/montelpro-shared-components-v2';

export const CompanyDeltaRow: FunctionComponent<{
	change?: CompanyDelta;
}> = ({ change }) =>
	change ? (
		<LabelAndValue
			label="Company"
			value={
				<HStack gap="md">
					{change?.name && (
						<>
							{change.name.from ? (
								<Link
									href={`/companies/${change.id?.from.toString()}`}
								>
									{change.name.from}
								</Link>
							) : (
								<div>(empty)</div>
							)}
							<div>→</div>
							{change.name.to ? (
								<Link
									href={`/companies/${change.id?.to.toString()}`}
								>
									{change.name.to}
								</Link>
							) : (
								<div>(empty)</div>
							)}
						</>
					)}
				</HStack>
			}
		/>
	) : null;
